module.exports = __webpack_public_path__ + "static/img/rui-gu-purse.925a753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rui-gu-purse.png
// module id = Ryic
// module chunks = 2